import { useUserPermissionOrFeatureFlagEnabled } from '../../taboola-common-frontend-modules/./account-configurations/hooks/useUserPermissionOrFeatureFlagEnabled';
import { FEATURE_FLAGS } from '../../taboola-common-frontend-modules/account-configurations';

export const useCustomContextualPermitted = () =>
    useUserPermissionOrFeatureFlagEnabled(
        'ADS_CONSOLE_CUSTOM_CONTEXTUAL',
        FEATURE_FLAGS.ADS_CONSOLE_CUSTOM_CONTEXTUAL_ALLOWED
    );
